export const adaptPaciente = (pacienteData) => {    
    return {
        id: pacienteData?.idPaciente,
        displayName: pacienteData?.nombre,
        name: pacienteData?.nombre
    }
}

export const adaptPacienteArray = (
    pacientes
) => {
    return structuredClone(pacientes?.pacientesRIEV.valorEsperado)
        ?.map(paciente => adaptPaciente(paciente));
}